import { useState, useEffect } from "react";
import {
  Grid,
  InputLabel,
  OutlinedInput,
  Stack,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import AnimateButton from "../../../Layout/components/@extended/AnimateButton";
import LoadingSpinner from "../../../Layout/components/LoadingSpinner";
import axios from "axios";

const ReceivePayment = ({
  jrData,
  setReceivePaymentModal,
  editingAccount,
  fetchManualPaymentDetails,
}) => {
  console.log(jrData);
  const [formData, setFormData] = useState({
    date: editingAccount ? editingAccount.payment_date : "",
    receivedAmount: editingAccount ? editingAccount.received_amount : "",
    jrRef: jrData.job_id,
    bankAccount: editingAccount ? editingAccount.received_bank_account : "",
    notes: editingAccount ? editingAccount.notes : "",
  });
  const [bankAccountReceivable, setBankAccountReceivable] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;

    // Optional: limit received amount to numeric
    if (name === "receivedAmount" && !/^\d*\.?\d*$/.test(value)) return;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(() => {
    axios.get("/manualPayment/receivableAccountDetails").then((res) => {
      console.log(res.data.receivableAccountDetails);
      const accounts = res.data.receivableAccountDetails || [];
      setBankAccountReceivable(accounts);
    });
  }, []);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      if (editingAccount) {
        // Update the receivable account if editingAccount is provided
        await axios.post(
          `/manualPayment/updateManualPayment/${editingAccount.received_payment_id}`,
          {
            PaymentDate: formData.date,
            ReceivedAmount: formData.receivedAmount,
            BankAccount: formData.bankAccount,

            Notes: formData.notes,
          }
        );
      } else {
        // Add a new receivable account if editingAccount is not provided
        await axios.post("/manualPayment/addPaymentDetails", {
          PaymentDate: formData.date,
          ReceivedAmount: formData.receivedAmount,
          BankAccount: formData.bankAccount,
          JobRef: formData.jrRef,
          Notes: formData.notes,
        });
      }
      fetchManualPaymentDetails(); // Refresh the list of payment details
      setReceivePaymentModal(false); // Close the modal
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to save payment details.");
    }
  };

  return (
    <LoadingSpinner isActive={submitting}>
      <Grid container spacing={2}>
        <Grid item xs={6} sm={6}>
          <Stack spacing={1}>
            <InputLabel>Date</InputLabel>
            <OutlinedInput
              required
              name="date"
              type="date"
              value={formData.date}
              onChange={handleChange}
            />
          </Stack>
        </Grid>

        <Grid item xs={6} sm={6}>
          <Stack spacing={1}>
            <InputLabel>Received Amount</InputLabel>
            <OutlinedInput
              required
              name="receivedAmount"
              type="text"
              value={formData.receivedAmount}
              onChange={handleChange}
              placeholder="Amount"
            />
          </Stack>
        </Grid>
        <Grid item xs={9} sm={9} md={9}>
          <Stack spacing={1}>
            <InputLabel>Bank Account</InputLabel>
            <Select
              fullWidth
              value={formData.bankAccount}
              onChange={(e) =>
                setFormData({ ...formData, bankAccount: e.target.value })
              }
              displayEmpty
            >
              <MenuItem value="" disabled>
                Select bank account
              </MenuItem>
              {bankAccountReceivable.map((account) => (
                <MenuItem
                  key={account.receivable_account_id}
                  value={account.receivable_account_number}
                >
                  {account.vendor_name} - ****
                  {account.receivable_account_number.slice(-4)}
                </MenuItem>
              ))}
            </Select>
          </Stack>
        </Grid>

        <Grid item xs={3} sm={3}>
          <Stack spacing={1}>
            <InputLabel>JR Ref</InputLabel>
            <OutlinedInput
              name="jrRef"
              type="text"
              value={formData.jrRef}
              disabled
            />
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Stack spacing={1}>
            <InputLabel>Notes</InputLabel>
            <OutlinedInput
              name="notes"
              type="text"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Add any notes"
            />
          </Stack>
        </Grid>

        <Grid item xs={12} mt={3}>
          <AnimateButton>
            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setReceivePaymentModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </Stack>
          </AnimateButton>
        </Grid>
      </Grid>
    </LoadingSpinner>
  );
};

export default ReceivePayment;
